import useBodyScrollLock from '@hooks/useBodyScrollLock';
import SvgAngleLeft from '@img/icons/angle-left.svg';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import * as React from 'react';
import S from './MobileNavigation.styles';
const MobileNavigation = (props) => {
    const ref = useBodyScrollLock(props.isActive);
    const [stackItems, setStackItems] = React.useState([]);
    const isFirstLevel = stackItems.length === 0;
    const currentParentItem = stackItems?.[stackItems.length - 1];
    const currentItemList = currentParentItem?.children ?? props.items;
    React.useEffect(() => {
        if (!props.isActive) {
            setStackItems([]);
        }
    }, [props.isActive]);
    return (React.createElement(S.Container, { ref: ref, id: "navigation-mobile", "aria-label": "Mobile Navigation", "aria-hidden": !props.isActive },
        React.createElement(S.ItemList, { "data-navigation": "main" },
            currentParentItem && (React.createElement(React.Fragment, null,
                React.createElement(S.Item, { "data-back": "true" },
                    React.createElement(S.Back, { onClick: (event) => {
                            event.preventDefault();
                            setStackItems([...stackItems.slice(0, stackItems.length - 1)]);
                        } },
                        React.createElement(SvgAngleLeft, null),
                        React.createElement("span", null, "Back"))))),
            !isFirstLevel && (React.createElement(S.Item, { "data-no-border": true },
                React.createElement(S.CategoryTitle, null, currentParentItem?.text))),
            currentItemList &&
                currentItemList.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.Link, { href: item.url, target: item.target, "data-bold": isFirstLevel || !!item.children?.length, onClick: (event) => {
                            const target = event.target;
                            const isArrowClick = target.closest('[data-arrow-button]');
                            if (isArrowClick) {
                                event.preventDefault();
                                setStackItems([...stackItems, item]);
                            }
                        } },
                        React.createElement("span", null, item.text),
                        !!item.children?.length && (React.createElement(S.ArrowButton, { "data-arrow-button": true },
                            React.createElement(SvgArrowRight, null)))))))),
        isFirstLevel && props.secondaryItems && (React.createElement(S.ItemList, { "data-navigation": "secondary" },
            props.secondaryItems.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { href: item.url, target: item.target, onClick: (event) => {
                        const target = event.target;
                        const isArrowClick = target.closest('[data-arrow-button]');
                        if (isArrowClick) {
                            event.preventDefault();
                            setStackItems([...stackItems, item]);
                        }
                    } },
                    React.createElement("span", null, item.text),
                    !!item.children?.length && (React.createElement(S.ArrowButton, { "data-arrow-button": true },
                        React.createElement(SvgArrowRight, null))))))),
            props.signIn && props.signIn.buttonText && (React.createElement(S.Item, null,
                React.createElement(S.LinkButton, { type: 'button', onClick: () => props.setOpenModal() },
                    React.createElement("span", null, props.signIn.buttonText))))))));
};
export default MobileNavigation;
